export default [
  { value: 0, text: 'No hay Cliff' },
  { value: 3, text: '3 meses' },
  { value: 6, text: '6 meses' },
  { value: 12, text: '1 año' },
  { value: 18, text: '1,5 años' },
  { value: 24, text: '2 años' },
];
